import * as Yup from 'yup';
// multi language
import i18n from '@/locales/i18n';

export function buildYupLocale(_: unknown, t: any): void {
	Yup.setLocale({
		mixed: {
			default: {msg: 'validations.default'},
			required: {msg: 'validations.required'},
			oneOf: ({values}) => ({msg: 'validations.oneOf', params: values}),
			notOneOf: ({values}) => ({msg: 'validations.notOneOf', params: values}),
		},
		// use functions to generate an error object that includes the value from the schema
		string: {
			length: ({length}) => ({msg: 'validations.length', params: length}),
			min: ({min}) => ({msg: 'validations.min', params: min}),
			max: ({max}) => ({msg: 'validations.max', params: max}),
			matches: ({regex}) => ({msg: 'validations.matches', params: regex}),
			email: {msg: 'validations.email'},
			url: {msg: 'validations.url'},
			trim: {msg: 'validations.trim'},
			lowercase: {msg: 'validations.lowercase'},
			uppercase: {msg: 'validations.uppercase'},
		},
		number: {
			min: ({min}) => ({msg: 'validations.minNumber', params: min}),
			max: ({max}) => ({msg: 'validations.maxNumber', params: max}),
			lessThan: ({less}) => ({msg: 'validations.lessThan', params: less}),
			moreThan: ({more}) => ({msg: 'validations.moreThan', params: more}),
			positive: {msg: 'validations.positive'},
			negative: {msg: 'validations.negative'},
			integer: {msg: 'validations.integer'},
		},
	});
}

export function makeYupTranslatedError(error: any) {
	const errorObj = error.errors[0];
	const errorT = i18n.t(errorObj.msg, {...error.params});
	return `${errorT}. `;
}
